import { Box, Button, Grid, Typography } from "@mui/material"
import { IOrderPrint } from "../../../models/OrderManagement"
import TableComponent from "./TableComponent"
import BentleyLogo from "../../../_assets/images/bentley-logo.png";
import BasicPrintOrderHeader from "./BasicPrintOrderHeader";
import BasicPrintLeadsHeader from "./BasicPrintLeadsHeader";

type IProps = {
    data: IOrderPrint
    type: string
    isLead?: boolean
}

const BasicPrint = ({data, type, isLead}: IProps) => {

    const handlePrint = ()=>{
        window.print();
    }   

    return (
        <>
        <Box id="print" className='print-container'>
            {
            data && (
                <>
                <Grid container >
                    <img style={{ height: "40px" }} src={BentleyLogo} alt="bentley-logo" />
                </Grid>
                <Grid container wrap="nowrap" justifyContent="space-between" className="print-detail-container">

                    {(!(!!isLead)) && (
                        <BasicPrintOrderHeader data={data} />
                    )}
                    {(!!isLead) && (
                        <BasicPrintLeadsHeader data={data} />
                    )}


                </Grid>
                <Grid >
                    <Typography className="boat-model" >{data.modelYear} - {data.modelName}</Typography>
                </Grid>
                <Grid mt={3}>
                    <TableComponent data={data} type={type} />
                </Grid>
                <Grid mt={3}>
                    <Typography className="disc-text ">*Standards and options are subject to change</Typography>
                </Grid>
                <Grid container justifyContent="flex-end" spacing={2}>
                    <Grid item><Button className="print-btn btn" onClick={ handlePrint}>Print</Button></Grid>
                </Grid>
                </>
            )
            }
        </Box>
        </>
    )
    }



export default BasicPrint;